import { Signal } from "signals.js";
import { Country, WorldAssignment } from "@goodgamestudios/world-assignment";
export class GGSCountryController {

    /** Singleton */
    private static _instance: GGSCountryController;
    private _currentCountryChanged: Signal = new Signal(Country);


    constructor() {
        if (GGSCountryController._instance) {
            throw new Error("Calling constructor not allowed! Use getInstance instead.");
        }
    }

    public static get instance(): GGSCountryController {
        if (!GGSCountryController._instance) {
            GGSCountryController._instance = new GGSCountryController();
        }
        return GGSCountryController._instance;
    }

    /**
     *  contains all countries that are defined in the country.xml - probably not all of those are available in the game
     */
    public get activeCountries(): Country[] {
        //  we dont want to mess around with the countries that were loaded by worldassignment  - therefore WA is now giving us  ReadonlyArray<Country>
        // unfortunately at the moment we are in fact modifiying the list on the game side (very likely for QA / Dev purposes)  so to not break the api i am forcing the staticanalysis back to normal array
        // in a latter moment (see HTML-2006 ) we could change the api to ReadOnlyArray  and have just the QA-DEV commands cast as normal array in order to mutate the original list
        return (window.ggs.worldAssignment as WorldAssignment).facade.activeCountries as Country[];
    }

    /**
     * DEPRECATED
     * where possible used directly worldassignment.facade
     * @returns {Country}
     */
    public get currentCountry(): Country {
        return (window.ggs.worldAssignment as WorldAssignment).facade.currentCountry;
    }


    public get currentCountryChanged(): Signal {
        return this._currentCountryChanged;
    }

}
